export default __webpack_public_path__ + "static/media/bnsactive.2526b185.png";